import React from "react";

function CourseCardSkeleton() {
  return (
    <div role="status"  className="bg-white  animate-pulse w-[240px] md:w-[305px] lg:w-auto flex-shrink-0 drop-shadow-2xl lg:drop-shadow-3xl flex flex-col items-center text-center p-[20px] text-primary lg:px-[1.93rem] lg:py-[2.5rem] rounded-[3.5rem] lg:rounded-2xl ">
      <div className="h-2.5 bg-gray400 rounded-full w-52 mb-4"></div>
      <div className="h-2.5 bg-gray400 rounded-full w-32 mb-4"></div>
      <div className="flex gap-1 ">
        {" "}
        {[1, 2, 3].map((tag) => (
          <div
            key={tag}
            className="h-5 bg-gray400 rounded-full w-10 mb-4"
          ></div>
        ))}
      </div>

      <div className="w-[50%] lg:w-[18.75rem] lg:h-[18.75rem] h-auto my-6">
        {" "}
        <div className="flex items-center justify-center h-full w-full mb-4 bg-gray-300 rounded dark:bg-gray-700">
          <svg
            className="w-32 h-32 text-gray-200 dark:text-gray-600"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="#00000038"
            viewBox="0 0 16 20"
          >
            <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
            <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
          </svg>
        </div>
      </div>
      <div className="h-2 bg-gray400  rounded-full w-60 mb-4"></div>
      <div className="h-2 bg-gray400  rounded-full w-60  mb-4"></div>
      <div className="h-2 bg-gray400  rounded-full w-60  mb-4"></div>

     
    </div>
  );
}

export default CourseCardSkeleton;
